module.exports = __webpack_public_path__ + "img/banner-list-2.f527ebe8.svg";